import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPackageRemove: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="package-remove,delivery"><path d="M13.25 20.25H3.75V3.75H8.75M8.75 3.75H15.25M8.75 3.75V9.25H15.25V3.75M15.25 3.75H20.25V12.25M20.8713 15.6287L18.75 17.75M18.75 17.75L16.6287 19.8713M18.75 17.75L16.6287 15.6287M18.75 17.75L20.8713 19.8713" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconPackageRemove;
